import { styled } from 'styled-components'

export { RIGID_PAGE_MAX_WIDTH } from './constants'

export const RigidPage = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`
